<template>
    <div class="my-order-sidebar sticky shadow">
        <div class="sidebar-header shadow-sm">
            <h5 class="h5 m-0">Your order</h5>
        </div>
        <div class="sidebar-body" :class="{ 'scroll-y': cartItems.length }">
            <div class="empty-cart" v-if="!cartItems.length">
                <p class="info">no items</p>
            </div>
            <!-- order item -->
            <ul class="order-list" v-if="cartItems">
                <li class="order-item" v-for="(cartItem, index) in cartItems" :key="'cartItem-' + index">
                    <div class="d-flex flex-row">
                        <span class="order-quanity text-primary">{{cartItem.quantity}} </span>
                        <span class="order-list-header flex-grow-1 text-justify"> {{cartItem.item.title}} </span>                                              
                        <div class="flex-shrink-1 text-center">
                            <span class="order-quanity text-primary">{{(cartItem.total_price/100.0) | currency}}</span>                                                                     
                            <div class="" v-if="type !== 'order'" >
                                <button 
                                    class="btn btn-link btn-sm"
                                    @click="edit(index)"
                                    type="button">
                                    <i class="fas fa-pencil-alt" />
                                </button>
                                <button 
                                    class="btn btn-link btn-sm"
                                    @click="delete_item(index)"
                                    type="button">
                                    <i class="far fa-trash-alt" />
                                </button>                        
                            </div>
                        </div>                         
                    </div>
                    <div  v-if="cartItem.special_note" class="font-italic">***{{cartItem.special_note}}</div>                    
                    <div class="order-item-options">
                        <div v-for="(option, index) in cartItem.selected_option_names" :key="`option-${index}-${index}`">
                          <span class="px-1"></span>
                          <span class="text-primary text-center" v-if="cartItem.size[index] > 1">{{cartItem.size[index]}}x</span> 
                          <span class="text-justify">{{option}}</span>
                        </div>                        
                    </div>                    
                </li>
            </ul>
        </div>
        <div class="sidebar-footer" v-if="cartTotal.qty">
            <div class="sidebar-footer-order-price-info my-2">
                <ul>
                    <li>
                        <span class="weight-700">Subtotal</span>
                        <span class="weight-700">{{(cartTotal.sum /100.0) | currency}}</span>
                    </li>
                    <li v-if="getState.tax > 0">
                        <span>{{getState.taxName1}}</span>
                        <span class="weight-700">{{cart_tax(getState.tax) / 100.0 | currency}}</span>
                    </li>                    
                    <li v-if="getState.tax2 > 0">
                        <span>{{getState.taxName2}}</span>
                        <span class="weight-700">{{cart_tax(getState.tax2) / 100.0 | currency}}</span>
                    </li>                    
                    <li v-if="type === 'total' || type === 'order'">
                        <span>Tip</span>
                        <span class="weight-700">{{ tipPrice | currency}}</span>
                    </li>
                </ul>
            </div>
            <div v-if="type==='checkout'" class="btn btn-primary btn-block checkout" @click="onCheckout">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <i class="fas fa-shopping-cart"></i> Pay ({{cartTotal.qty}})
                    </div>
                    <div>{{checkout_price() / 100.0 | currency}}</div>
                </div>
            </div>
            <div v-if="type==='total' || type === 'order'" class="btn btn-primary d-flex justify-content-between align-items-center checkout">
                <div>
                    Total
                </div>
                <div class="font-weight-normal mb-0">{{total_price() / 100.0 | currency}}</div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'checkout'
        },
    },
    computed: {
        cartItems() 
        {        
            return this.$store.getters.cartItems;
        },

        cartTotal()
        {
            return this.$store.getters.cartTotal;
        },

        getState(){
            return this.$store.getters.getState;
        },

        tipPrice() {
            return this.$store.getters.tipAmount
        }
    },

    methods: {
        /**
         * 
         */
        edit(index)
        {
            this.$emit('editCartItem', index);
        },

        /**
         * 
         * 
         */
        delete_item(index)
        {
            this.$store.dispatch('customerLog', "Item, " +  `"${this.cartItems[index].item.title}"` + " Removed");            
            this.$store.dispatch('deleteCartItem', index);
        },

        /**
         * 
         * 
         */
        cart_tax(taxRate)
        {

            var calculate = this.cartTotal.sum && taxRate ? (this.cartTotal.sum * taxRate) / 100.0 : 0;
            
            return Math.round(calculate);
        },

        /**
         * 
         */
        checkout_price()
        {
            return this.cartTotal.sum + this.cart_tax(this.getState.tax) + this.cart_tax(this.getState.tax2);
        },

        total_price() {
            return this.cartTotal.sum + this.tipPrice * 100.0 + this.cart_tax(this.getState.tax) + this.cart_tax(this.getState.tax2)
        },
        onCheckout() {
            this.$store.dispatch('customerLog', "Checkout");         
            this.$router.push({ path: '/checkout' })
        }
    }
}
</script>

<style lang="scss" scoped>
.checkout{
    border-radius: 0px 0px 5px 5px;
}
</style>